<template>
  <div>
    <q-card v-if="marker.name" square flat bordered class="my-card bg-grey-1">
      <q-card-section>
        <div class="row items-center no-wrap">
          <div class="col">
            <div class="text-grey-brand text-subtitle1 text-bold">
              Marker Name: {{ marker ? marker.name : '' }}
            </div>
          </div>
        </div>
        <p>
          Marker Description:
          {{ marker && marker.description ? marker.description : 'AGM' }}
        </p>
        <p>
          State:
          {{
            marker
              ? marker.trackState === 'T'
                ? 'Track'
                : marker.trackState === 'S'
                ? 'Skip'
                : marker.trackState
              : ''
          }}
        </p>
        <p v-if="linkedUid && !isCompletedRun">Linked UID: {{ linkedUid }}</p>
        <p v-if="!isCompletedRun">ETA to marker: {{ etaFormated }}</p>
        <p v-if="marker.note">Note: {{ marker.note }}</p>
        <span
          v-if="
            !isCompletedRun &&
            marker.trackState === 'T' &&
            !linkedUid &&
            (getuser() === 'admin' || getuser() === 'superadmin')
          "
        >
          <q-btn
            dense
            no-caps
            class="q-mb-sm btn-brand"
            :disabled="!isOnline"
            @click="onAssignUid"
            >Assign UID</q-btn
          >
          <br />
        </span>
        <span
          v-if="
            !isCompletedRun &&
            marker.trackState === 'T' &&
            linkedUid &&
            (getuser() === 'admin' || getuser() === 'superadmin')
          "
        >
          <q-btn
            dense
            no-caps
            class="q-mb-sm btn-brand"
            :disabled="!isOnline"
            @click="onUnlinkUid"
            >Unlink UID</q-btn
          >
          <br />
        </span>
        <span
          v-if="
            (marker.trackState === 'T' || isEndpointMarker) &&
            (getuser() === 'admin' || getuser() === 'superadmin')
          "
        >
          <q-btn
            dense
            no-caps
            class="q-mb-sm btn-brand"
            :disabled="!isOnline"
            @click="onAddPassage"
            >Add Manual Passage</q-btn
          >
          <br />
        </span>
        <span v-if="marker.trackState === 'T' || isEndpointMarker">
          <q-btn
            dense
            no-caps
            class="q-mb-sm btn-brand"
            :disabled="!isOnline"
            @click="onViewPassages"
            >View Passages</q-btn
          >
          <br />
        </span>
        <q-btn
          v-if="
            !isCompletedRun &&
            (getuser() == 'admin' || getuser() == 'superadmin')
          "
          dense
          no-caps
          class="q-mb-sm btn-brand"
          :disabled="!isOnline"
          @click="onChangeState"
          >{{
            marker.trackState === 'S' ? 'Change to TRACK' : 'Change to SKIP'
          }}</q-btn
        >
        <br v-if="!isCompletedRun" />
        <span>
          <q-btn-dropdown
            v-if="
              !isCompletedRun &&
              (getuser() == 'admin' || getuser() == 'superadmin') &&
              !isEndpointMarker
            "
            dense
            no-caps
            class="q-mb-sm btn-brand"
            label="Change Marker Description"
            :disabled="!isOnline"
          >
            <q-list>
              <q-item
                v-for="(description, index) in markerDescriptions"
                :key="index"
                v-close-popup
                clickable
                @click="onChangeDescription(description.toUpperCase())"
              >
                <q-item-section>
                  <q-item-label>{{ description }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </span>
        <br v-if="!isCompletedRun" />
        <q-btn
          v-if="getuser() == 'admin' || getuser() == 'superadmin'"
          dense
          no-caps
          class="q-mb-sm btn-brand"
          :disabled="!isOnline"
          @click="onAddNote"
          >Add Note
        </q-btn>
        <br />
      </q-card-section>
    </q-card>
    <q-card v-else square flat bordered class="my-card bg-grey-1">
      <q-card-section>
        <div class="row items-center no-wrap">
          <div class="col">
            <div class="text-h6 text-weight-bold text-grey-brand">
              No Marker Selected
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>

    <q-dialog v-model="addPassageDialog">
      <q-card>
        <q-toolbar>
          <div class="text-blue-brand text-bold">Add Passage</div>
          <q-space />
          <q-btn
            flat
            round
            dense
            icon="close"
            @click="addPassageDialog = false"
          />
        </q-toolbar>
        <q-card-section>
          <q-form>
            <div class="column">
              <div class="col q-pb-sm">
                <q-input
                  v-model="passageTimestamp"
                  dense
                  filled
                  label="Passage Time (UTC)"
                >
                  <template #prepend>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="passageTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                  <template #append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time
                          v-model="passageTimestamp"
                          mask="YYYY-MM-DD HH:mm:ss"
                          format24h
                        />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn
                class="btn-brand"
                label="Cancel"
                no-caps
                @click="addPassageDialog = false"
              />
              <q-btn
                class="btn-brand"
                label="Add"
                type="button"
                no-caps
                @click="onAddPassageConfirm"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="assignUidDialog">
      <q-card style="width: 300px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Assign UID</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <q-form>
            <div v-if="availableUids.length" class="column">
              <div class="col q-pb-sm">
                Link marker <b>{{ marker.name }}</b> to AGM Device UID
              </div>
              <div class="col q-pb-sm">
                <q-select
                  v-model="selectedUid"
                  dense
                  color="blue-brand"
                  autofocus
                  outlined
                  :options="availableUids"
                  label="AGM Device UID"
                />
              </div>
            </div>
            <div v-else class="column">
              No AGMs have been assigned to this pig run
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn v-close-popup class="btn-brand" label="Cancel" no-caps />
              <q-btn
                v-close-popup
                class="btn-brand"
                label="Link"
                type="button"
                :disabled="!selectedUid"
                no-caps
                @click="onSaveUidLink"
              />
            </q-card-actions>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <q-dialog v-model="addNoteDialog">
      <q-card style="width: 350px; max-width: 90vw">
        <q-toolbar>
          <q-toolbar-title class="text-blue-brand text-bold"
            >Add Note</q-toolbar-title
          >
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
        <q-card-section>
          <div v-if="noteLoading" class="row justify-center q-pa-md">
            <q-spinner color="primary" size="2em" />
          </div>
          <form v-else>
            <div class="column">
              <q-input
                v-model="noteText"
                filled
                type="textarea"
                autogrow
                autofocus
                dense
              />
            </div>
            <q-separator />
            <q-card-actions align="center">
              <q-btn
                v-close-popup
                class="btn-brand"
                label="Save"
                no-caps
                @click="onSaveNote"
              />
            </q-card-actions>
          </form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <PipelineSectionMarkerPassagesDialog ref="passagesDialog" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SelectedMarker } from '../models/PigRunState';
import {
  PipelineSectionMarkerState,
  PigRunMapEntry,
} from '../models/PigRunState';
import { AddManualPassageRequest } from '../models/ReportManager/AddManualPassageRequest';
import { UpdateMarkerTrackStateRequest } from '../models/UpdateMarkerTrackStateRequest';
import { UpdateMarkerNoteRequest } from '../models/UpdateMarkerNoteRequest';
import { UpdateMarkerDescriptionRequest } from '../models/UpdateMarkerDescriptionRequest';
import PigRunService from '../services/PigRunService';
import { validatePassageVerification } from '../utils/PassageValidation';
import { sortUidsAscending } from '../utils/UidSort';
import {
  formatMarkerEta,
  MarkerEtaInfo,
  resolveMarkerEta,
} from '../services/TrackingWorksheetBuilder';
import PipelineSectionMarkerPassagesDialog from '@/components/PipelineSectionMarkerPassagesDialog.vue';

export default defineComponent({
  name: 'MarkerActions',
  components: {
    PipelineSectionMarkerPassagesDialog,
  },
  data() {
    return {
      isOnline: true,
      eta: 0,
      // Ticking clock for the "ETA to marker" countdown (EN-1495): new Date()
      // inside a computed is not reactive, so the text only changed when a
      // SignalR update arrived. It ticks only while the popup is open
      // (setPopupOpen, called by LeafletMap) and only re-formats the
      // countdown (EN-1495 review round 2, R2-8).
      now: new Date(),
      clockInterval: null as ReturnType<typeof setInterval> | null,
      popupOpen: false,
      linkedUid: null as number | null,
      pigRunDevices: [] as { pigRunDeviceId: number; uid: number }[],
      linkedUidsOnOtherMarkers: new Set<number>(),
      assignUidDialog: false,
      selectedUid: null as number | null,
      addPassageDialog: false,
      passageTimestamp: '',
      addNoteDialog: false,
      noteText: '',
      noteLoading: false,
      markerDescriptions: [
        'AGM',
        'Tap',
        'Magnet',
        'Bend',
        'Weld',
        'Attachment',
        'Tee',
        'Pipe',
        'Other',
      ],
    };
  },
  computed: {
    marker(): SelectedMarker & {
      note?: string;
    } {
      const sel = this.$store.state.selectedMarker as SelectedMarker;
      if (!sel || !sel.name) return {} as any;

      const storeMarker = this.storeMarker;
      return {
        ...sel,
        trackState: storeMarker?.trackState ?? sel.trackState,
        note: undefined,
      };
    },
    storeMarker(): PipelineSectionMarkerState | undefined {
      const sel = this.$store.state.selectedMarker as SelectedMarker;
      if (!sel?.pigRunId) return undefined;
      const entry = (
        this.$store.state.pigRun.pigRuns as Record<number, PigRunMapEntry>
      )[sel.pigRunId];
      if (!entry) return undefined;
      return entry.markers.find(
        (m) => m.pipelineSectionMarkerId === sel.pipelineSectionMarkerId
      );
    },
    availableUids(): number[] {
      return sortUidsAscending(
        this.pigRunDevices
          .map((d) => d.uid)
          .filter((uid) => !this.linkedUidsOnOtherMarkers.has(uid))
      );
    },
    isEndpointMarker(): boolean {
      return (
        this.marker.description === 'LAUNCH' ||
        this.marker.description === 'RECEIVE'
      );
    },
    isCompletedRun(): boolean {
      const sel = this.$store.state.selectedMarker as SelectedMarker;
      if (!sel?.pigRunId) return false;
      return !(
        this.$store.state.pigRun.pigRuns as Record<number, PigRunMapEntry>
      )[sel.pigRunId];
    },
    markerEtaInfo(): MarkerEtaInfo | null {
      const entry = this.pigRunEntry;
      if (!entry?.pigLocation) return null;
      // EN-1495: the selected marker's own ETA. SignalR etaToNext is a
      // constant placeholder (5.0), which showed as "ETA to marker: 5".
      // Does not depend on this.now, so the worksheet is rebuilt only when
      // the run data or the selected marker changes, not every second (R2-8).
      const sel = this.$store.state.selectedMarker as SelectedMarker;
      return resolveMarkerEta(entry, sel.pipelineSectionMarkerId, new Date());
    },
    etaFormated(): string {
      const info = this.markerEtaInfo;
      return info ? formatMarkerEta(info, this.now) : '';
    },
    pigRunEntry(): PigRunMapEntry | undefined {
      const sel = this.$store.state.selectedMarker as SelectedMarker;
      if (!sel?.pigRunId) return undefined;
      return (
        this.$store.state.pigRun.pigRuns as Record<number, PigRunMapEntry>
      )[sel.pigRunId];
    },
  },
  watch: {
    marker: {
      immediate: false,
      handler(newMarker: SelectedMarker) {
        this.linkedUid = null;
        this.now = new Date();
        if (!newMarker?.pigRunId) return;
        const entry = (
          this.$store.state.pigRun.pigRuns as Record<number, PigRunMapEntry>
        )[newMarker.pigRunId];
        if (entry?.pigRun?.type === 'LT') {
          this.pigRunDevices = Array.isArray(entry.pigRun.devices)
            ? entry.pigRun.devices
            : [];
          const markers = entry.markers;
          const otherLinked = new Set<number>();
          for (const m of markers) {
            if (
              m.pipelineSectionMarkerId === newMarker.pipelineSectionMarkerId
            ) {
              if (m.manualLinkDevices?.length > 0) {
                this.linkedUid = m.manualLinkDevices[0].uid;
              }
            } else if (m.manualLinkDevices?.length > 0) {
              otherLinked.add(m.manualLinkDevices[0].uid);
            }
          }
          this.linkedUidsOnOtherMarkers = otherLinked;
        }
      },
    },
  },
  beforeUnmount() {
    this.setPopupOpen(false);
  },
  methods: {
    /**
     * Called by LeafletMap on the map's popupopen/popupclose for this
     * component's popup. The countdown clock runs only while it is open.
     */
    setPopupOpen(open: boolean): void {
      this.popupOpen = open;
      if (this.clockInterval) {
        clearInterval(this.clockInterval);
        this.clockInterval = null;
      }
      if (!open) return;

      this.now = new Date();
      this.clockInterval = setInterval(() => {
        // Only a live run's marker has a countdown.
        if (this.markerEtaInfo) this.now = new Date();
      }, 1000);
    },
    getuser(): string {
      const user = this.$store.state.user;
      return user?.role ?? '';
    },
    onAssignUid() {
      this.selectedUid = null;
      this.assignUidDialog = true;
    },
    async onSaveUidLink() {
      if (!this.selectedUid) return;
      try {
        await PigRunService.addManualLink(
          this.marker.pipelineSectionMarkerId,
          this.selectedUid
        );
        this.linkedUid = this.selectedUid;
        await this.$store.dispatch('refreshSinglePigRun', {
          pigRunId: this.marker.pigRunId,
          force: true,
        });
      } catch (error: any) {
        if (error?.response?.status === 409) {
          this.$q.notify({
            color: 'negative',
            message: `UID ${this.selectedUid} is already linked to another marker on this pig run.`,
          });
        } else {
          console.error('Failed to add manual link:', error);
        }
      }
    },
    async onUnlinkUid() {
      try {
        await PigRunService.removeManualLink(
          this.marker.pipelineSectionMarkerId
        );
        this.linkedUid = null;
        await this.$store.dispatch('refreshSinglePigRun', {
          pigRunId: this.marker.pigRunId,
          force: true,
        });
      } catch (error) {
        console.error('Failed to remove manual link:', error);
      }
    },
    async onAddPassage() {
      try {
        const response = await PigRunService.hasVerifiedPassageAtMarker(
          this.marker.pipelineSectionMarkerId
        );
        if (response.data === true) {
          this.$q.notify({
            type: 'warning',
            timeout: 0,
            actions: [{ icon: 'close', color: 'white', round: true }],
            message:
              'This marker already has a verified passage. Manual passages are verified by default and cannot be added when a verified passage already exists.',
          });
          return;
        }
      } catch (error) {
        console.error('Failed to check verified passage status:', error);
        this.$q.notify({
          type: 'negative',
          message: 'Unable to add manual passage. Please try again.',
        });
        return;
      }

      const now = new Date();
      const pad = (n: number) => String(n).padStart(2, '0');
      this.passageTimestamp = `${now.getUTCFullYear()}-${pad(
        now.getUTCMonth() + 1
      )}-${pad(now.getUTCDate())} ${pad(now.getUTCHours())}:${pad(
        now.getUTCMinutes()
      )}:${pad(now.getUTCSeconds())}`;
      this.addPassageDialog = true;
    },
    async onAddPassageConfirm() {
      const passageTime = new Date(this.passageTimestamp + 'Z');

      // Validate passage timestamp ordering against verified passages at other markers
      const check = await validatePassageVerification(
        this.marker.pipelineSectionMarkerId,
        this.marker.pigRunId,
        passageTime
      );
      if (!check.valid) {
        this.$q.notify({
          type: check.warning ? 'warning' : 'negative',
          timeout: check.warning ? 0 : undefined,
          actions: check.warning
            ? [{ icon: 'close', color: 'white', round: true }]
            : undefined,
          message:
            check.warning ?? check.error ?? 'Unable to add manual passage.',
        });
        this.addPassageDialog = false;
        return;
      }

      const request = new AddManualPassageRequest(
        this.marker.pipelineSectionMarkerId,
        passageTime
      );
      try {
        await PigRunService.addManualPassage(request);
        this.$store.dispatch('refreshSinglePigRun', {
          pigRunId: this.marker.pigRunId,
          force: true,
        });
      } catch (error) {
        console.error('Failed to add manual passage:', error);
      }
      this.addPassageDialog = false;
    },
    onViewPassages() {
      (this.$refs.passagesDialog as any).openNew(
        this.marker.pipelineSectionMarkerId,
        this.marker.name,
        this.marker.pigRunId
      );
    },
    async onChangeState() {
      const newState = this.marker.trackState === 'S' ? 'T' : 'S';

      if (newState === 'S') {
        try {
          const response = await PigRunService.hasVerifiedPassageAtMarker(
            this.marker.pipelineSectionMarkerId
          );
          if (response.data === true) {
            this.$q.notify({
              type: 'warning',
              timeout: 0,
              actions: [{ icon: 'close', color: 'white', round: true }],
              message:
                'Cannot change marker to Skip. This marker has a verified passage.',
            });
            return;
          }
        } catch (error) {
          console.error('Failed to check verified passage status:', error);
          this.$q.notify({
            type: 'negative',
            message: 'Unable to change marker state. Please try again.',
          });
          return;
        }
      }

      const request: UpdateMarkerTrackStateRequest = {
        pipelineSectionMarkerId: this.marker.pipelineSectionMarkerId,
        trackState: newState,
      };
      try {
        await PigRunService.updateMarkerTrackState(request);
        this.$store.commit('UPDATE_MARKER', {
          pigRunId: this.marker.pigRunId,
          pipelineSectionMarkerId: this.marker.pipelineSectionMarkerId,
          fields: { trackState: newState },
        });
        this.$store.commit('SET_SELECTED_MARKER', {
          ...this.$store.state.selectedMarker,
          trackState: newState,
        });
        this.$q.notify({
          type: 'positive',
          message: `Marker state changed to ${
            newState === 'T' ? 'Track' : 'Skip'
          }.`,
        });
      } catch (error: any) {
        console.error('Failed to update marker track state:', error);
        const msg =
          error?.response?.status === 400 && error?.response?.data
            ? String(error.response.data)
            : 'Failed to update marker track state.';
        this.$q.notify({ type: 'negative', message: msg });
      }
    },
    async onChangeDescription(description: string) {
      const request: UpdateMarkerDescriptionRequest = {
        pipelineSectionMarkerId: this.marker.pipelineSectionMarkerId,
        description: description,
      };
      try {
        await PigRunService.updateMarkerDescription(request);
        this.$store.commit('UPDATE_MARKER', {
          pigRunId: this.marker.pigRunId,
          pipelineSectionMarkerId: this.marker.pipelineSectionMarkerId,
          fields: { description: description },
        });
        this.$store.commit('SET_SELECTED_MARKER', {
          ...this.$store.state.selectedMarker,
          description: description,
        });
        this.$q.notify({
          type: 'positive',
          message: `Marker description changed to ${description}.`,
        });
      } catch (error: any) {
        console.error('Failed to update marker description:', error);
        this.$q.notify({
          type: 'negative',
          message: 'Failed to update marker description.',
        });
      }
    },
    async onAddNote() {
      this.noteText = '';
      this.noteLoading = true;
      this.addNoteDialog = true;
      try {
        const response = await PigRunService.getPipelineSectionMarkerDetail(
          this.marker.pipelineSectionMarkerId
        );
        this.noteText = response.data.note ?? '';
      } catch (error) {
        console.error('Failed to fetch marker detail:', error);
      } finally {
        this.noteLoading = false;
      }
    },
    async onSaveNote() {
      const request: UpdateMarkerNoteRequest = {
        pipelineSectionMarkerId: this.marker.pipelineSectionMarkerId,
        note: this.noteText,
      };
      try {
        await PigRunService.updateMarkerNote(request);
        this.$store.commit('UPDATE_MARKER', {
          pigRunId: this.marker.pigRunId,
          pipelineSectionMarkerId: this.marker.pipelineSectionMarkerId,
          fields: { note: this.noteText },
        });
        this.$q.notify({
          type: 'positive',
          message: 'Note saved.',
        });
      } catch (error) {
        console.error('Failed to save marker note:', error);
        this.$q.notify({
          type: 'negative',
          message: 'Failed to save note.',
        });
      }
    },
    onDeleteMarker() {},
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
